import { motion } from "framer-motion";
import { ASSETS } from "@/lib/site";
import Reveal from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "It Learns Your Home",
    body: "Using high-resolution pressure sensing and AI, Leak SmartShield continuously learns your property's unique water usage patterns — building a living map of what 'normal' looks like.",
  },
  {
    n: "02",
    title: "It Detects The Invisible",
    body: "From hidden pipe leaks and dripping taps to running toilets and underground water losses, it identifies abnormal activity across your entire plumbing system — long before you'd ever notice.",
  },
  {
    n: "03",
    title: "It Alerts You Instantly",
    body: "The moment a potential leak is detected, a notification lands on your smartphone — wherever you are in the world. Full remote control sits in the palm of your hand.",
  },
  {
    n: "04",
    title: "It Shuts Off The Water",
    body: "If a major leak occurs, the integrated smart valve automatically shuts off your water supply within seconds — preventing extensive damage and expensive repair bills.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="relative bg-[#070707] py-28 lg:py-40 overflow-hidden"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${ASSETS.water})` }}
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#070707] via-[#070707]/70 to-[#070707]" />

      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="max-w-2xl">
          <Reveal>
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#169ED9]">
              / How the system works
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              An AI Security System For Your Plumbing.
            </h2>
          </Reveal>
        </div>

        <div className="mt-20 space-y-2">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div
                data-testid={`chapter-${c.n}`}
                className="group grid md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-white/10 py-10 lg:py-14 transition-colors duration-500 hover:bg-white/[0.02]"
              >
                <div className="md:col-span-3">
                  <span className="font-heading font-black tracking-tighter text-6xl lg:text-8xl text-white/10 group-hover:text-[#169ED9]/30 transition-colors duration-500">
                    {c.n}
                  </span>
                </div>
                <h3 className="md:col-span-4 font-heading font-bold text-2xl lg:text-3xl tracking-tight">
                  {c.title}
                </h3>
                <p className="md:col-span-5 text-white/55 leading-relaxed lg:pt-2">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </section>
  );
}
